import React, { useState } from 'react';
import $ from 'jquery';
import { Rnd } from 'react-rnd';
import panoJpg from '../../assets/img/pano.jpeg';
import { Button } from 'antd';
import SessionManager from '../../routes/SessionManager';
import Toastr from 'toastr';
import CommonUtils from '../../util/CommonUtils';

const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "solid 1px red",
    background: "transparent"
};

const PeepCamera = (props) => {
    const [modified, setModified] = useState(false);
    const [loading, setLoading] = useState(false);
    // const [width, setWidth] = useState(50);
    // const [height, setHeight] = useState(50);

    let allowBoxBeyondBounds = 1; // can vary from 0 to 1; 0 meaning wont allow out of container.

    let sessionManager = new SessionManager();
    let user = sessionManager.readCookie('user', true);

    const wh = [$('#axis-video').width(), $('#axis-video').height()];
    const ratio = wh[0] / wh[1];

    let ptz_settings = JSON.parse(JSON.stringify(props.ptz));

    for (let p of ['MaxPan', 'MinPan', 'MaxTilt', 'MinTilt', 'MaxZoom', 'MinZoom', 'pan', 'tilt', 'zoom'])
        ptz_settings[p] = parseFloat(ptz_settings[p]);

    if (props.zone && props.zone.location_config && props.zone.location_config.pano_controls) {
        let pano_ctrls = props.zone.location_config.pano_controls;
        ptz_settings['MinTilt'] = pano_ctrls['min_t'];
        ptz_settings['MaxTilt'] = pano_ctrls['max_t'];
        ptz_settings['MaxPan'] = pano_ctrls['max_p'];
        ptz_settings['MinPan'] = pano_ctrls['min_p'];
    }
    console.log('ptz_settings', JSON.stringify(ptz_settings, null, 2));

    const panRange = (ptz_settings.MaxPan - ptz_settings.MinPan);
    const tiltRange = (ptz_settings.MaxTilt - ptz_settings.MinTilt);

    let panUnit = (wh[0] * 0.8 / panRange);
    let tiltUnit = (wh[1] * 0.3 / tiltRange);

    console.log('panRange, tiltRange', [panRange, tiltRange]);
    // console.log('pan, tilt', [ptz_settings.pan, ptz_settings.tilt]);
    // console.log('panUnit,tiltUnit', [panUnit, tiltUnit]);


    let peepPosX = Math.abs(ptz_settings.pan - ptz_settings.MinPan);
    let peepPosY = Math.abs(ptz_settings.MaxTilt - ptz_settings.tilt); // tilt ranges from bottom(-ve) to up(+ve).

    let isXYValid = !(!(ptz_settings.pan >= ptz_settings.MinPan && ptz_settings.pan <= ptz_settings.MaxPan) ||
        !(ptz_settings.tilt >= ptz_settings.MinTilt && ptz_settings.tilt <= ptz_settings.MaxTilt));

    const [x, setX] = useState(isXYValid ? (peepPosX * panUnit) - (50 * ratio * 0.5) : 0);
    const [y, setY] = useState(isXYValid ? (peepPosY * tiltUnit) - 25 : 0);

    let pan1 = ptz_settings.MinPan + ((x + (50 * ratio * 0.5)) / panUnit);
    let tilt1 = ptz_settings.MaxTilt > 0 ? ptz_settings.MinTilt + ((y + 25) / tiltUnit) : - ((y + 25) / tiltUnit);

    console.log('pan1, tilt1', [pan1, tilt1]);

    const pano_view = 'pano';
    const peep_view = 'peep';

    const applychanges = () => {
        let pan = ptz_settings.MinPan + ((x + (50 * ratio * 0.5)) / panUnit);
        let tilt = ptz_settings.MaxTilt < 0 ? ptz_settings.MinTilt + ((y + 25) / tiltUnit) : - ((y + 25) / tiltUnit);
        setLoading(true);
        props.controlCamera('modify', { pan: pan, tilt: tilt, callback: setModified });
    }

    const generatePanoImage = () => {

        let payload = {
            customer_id: user.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token,
            form_input: {
                device_id: props.zone.device_id,
                location_id: props.zone.location_id,
                site_id: user.site_selected.site_id,
            }
        };

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/location/create_pano',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(payload)
            }
        ).then(
            (res) => {
                if (res.status) {
                    switch (res.status.code) {
                        case 200:
                            Toastr.success('Submitted Request successfully !');
                            break;

                        case 201:
                            Toastr.success('Already a request in progress ...');
                            break;

                        default:
                            break;
                    }

                } else {
                    console.log("Error occurred while submitting pano request");
                }
            },
            (res) => {
                console.log("Error occurred while submitting pano request");
            });
    }

    return (
        <>
            <div id={pano_view} style={{ left: (wh[0] * 0.1), width: (wh[0] * 0.8), height: '100px', top: (wh[1] - 150), backgroundImage: `url(${props.zone ? props.zone.pano_image || panoJpg : panoJpg})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat' }}>
                {modified && <Button style={{ marginTop: '-32px', float: 'right' }} loading={loading} type="primary" onClick={() => applychanges()}>Apply Changes</Button>}
                {CommonUtils.hasPermission('SITESUPT-UI-PANO-GENERATE') && <Button style={{ top: '-30px' }} type="primary" onClick={() => generatePanoImage()}>Generate Pano Image</Button>}

                <Rnd
                    id={peep_view}
                    style={style}
                    size={{ width: 50 * ratio, height: 50 }}
                    position={{ x: x, y: y }}
                    onDragStop={(e, position) => {
                        setModified(true);
                        setLoading(false);
                        let iWH = [$('#' + peep_view).width(), $('#' + peep_view).height()];
                        let allowed = [$('#' + pano_view).width() - iWH[0], $('#' + pano_view).height() - iWH[1]];
                        console.log([x, y]);

                        let _x = position.x;
                        _x = _x < 0 - (50 * ratio * allowBoxBeyondBounds) ? 0 : _x > allowed[0] + (50 * ratio * allowBoxBeyondBounds) ? allowed[0] : _x;
                        setX(_x);

                        let _y = position.y;
                        _y = _y < 0 - ((50 * allowBoxBeyondBounds)) ? 0 : _y > allowed[1] + (50 * allowBoxBeyondBounds) ? allowed[1] : _y;
                        setY(_y);
                    }}
                // onResize={(e, direction, ref, delta, position) => {
                //     setWidth(ref.offsetWidth);
                //     setHeight(ref.offsetHeight);
                // }}
                >
                </Rnd>
                {!props.zone.pano_image && <span>Panoramic image not found and needs to be generated ... </span>}
            </div >
        </>
    );
};

export default PeepCamera;
